"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _web = _interopRequireDefault(require("web3"));

var _bignumber = _interopRequireDefault(require("bignumber.js"));
/* global window */


var MWeb3 = typeof _web.default === 'function' ? _web.default : window.Web3;

var UnitConverter = /*#__PURE__*/function () {
  function UnitConverter() {
    (0, _classCallCheck2.default)(this, UnitConverter);
  }

  (0, _createClass2.default)(UnitConverter, null, [{
    key: "ETH",
    value: function (value) {
      return MWeb3.utils.toWei("".concat(value), 'ether');
    }
  }, {
    key: "Token",
    value: function (value, decimals) {
      return (0, _bignumber.default)(+value).times("1e+".concat(decimals));
    }
  }, {
    key: "FromWei",
    value: function (value, decimals) {
      return (0, _bignumber.default)(+value).div("1e+".concat(decimals !== null && decimals !== void 0 ? decimals : 18)).toNumber();
    }
  }]);
  return UnitConverter;
}();

module.exports = UnitConverter;